import { Button } from "@mui/material";
import colors from "../../assets/theme/light/colors";


function CustomButton({ disabled = false, onClick, label, color }) {
  return <Button onClick={onClick} disabled={disabled} style={{color: color ? color : colors.light_logo_blue}}>{label}</Button>;
}

export default CustomButton;
